import cn from "@/utils/class-names";
import { Select, SelectOption, SelectProps } from "rizzui";
import OptionCheckbox from "./templates/option-checkbox";

export interface MultiSelectProps extends SelectProps<SelectOption> {
  value: SelectOption[];
}

export default function MultiSelect({
  options,
  placeholder,
  dropdownClassName,
  getOptionDisplayValue,
  value,
  ...props
}: MultiSelectProps) {
  return (
    <Select
      inPortal={false}
      selectClassName="h-9 min-w-[150px]"
      dropdownClassName={cn("p-1.5 !z-10", dropdownClassName)}
      optionClassName="h-9"
      className="md:max-w-[215px] w-full"
      options={options}
      value={value || []}
      multiple
      displayValue={(selected: SelectOption[]) => {
        const selectedString = selected.map((item) => item.label);
        return selectedString?.join(", ");
      }}
      getOptionDisplayValue={(option: SelectOption) => {
        return (
          getOptionDisplayValue?.(option) ?? (
            <OptionCheckbox selected={value} option={option} />
          )
        );
      }}
      getOptionValue={(option) => {
        return option;
      }}
      {...props}
    />
  );
}
